import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IS_ACTION, IS_SEARCH } from 'src/app/shared/models/load.models';
import { QcResponse } from 'src/app/shared/models/qcResponse.model';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { LiteralsFacadeService } from 'src/app/shared/services/literals.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { SearchGroupTemplatesFacadeService } from './search-group-templates.facade.service';

@Injectable({ providedIn: 'root' })
export class SearchGroupTemplatesService {
  constructor(
    private http: HttpClient,
    private environmentFacade: EnvironmentFacadeService,
    private searchGroupTemplatesFacade: SearchGroupTemplatesFacadeService,
    private paginatorFacadeService: PaginatorFacadeService,
    private literalsFacade: LiteralsFacadeService,
  ) {}

  getGroupTemplates(): Observable<QcResponse> {
    const body = {
      criteriaList: [
        {
          criteriaType: 'BOOKCOUPON_GROUP_TEMPLATE_DEACTIVATED_CRITERIA',
          deactivated: this.searchGroupTemplatesFacade.inactive,
        },
        {
          criteriaType: 'BOOKCOUPON_GROUP_TEMPLATE_CODE_CRITERIA',
          code: this.searchGroupTemplatesFacade.code,
        },
        {
          criteriaType: 'BOOKCOUPON_GROUP_TEMPLATE_REMARKS_CRITERIA',
          remarks: this.searchGroupTemplatesFacade.remarks,
        },
      ],
      pagination: {
        page: this.paginatorFacadeService.pageIndex + 1,
        pageSize: this.paginatorFacadeService.itemsNumber,
      },
      sorting: {
        sortingField:
          this.paginatorFacadeService.selectedSortField ===
          this.literalsFacade.literals.literals['liquid.search.sort.tags.creation_date']
            ? 'CREATION_DATE'
            : 'CREATION_DATE',
        sortingOrder:
          this.paginatorFacadeService.selectedOrder === this.literalsFacade.literals.literals['liquid.search.sort.asc']
            ? 'ASC'
            : 'DESC',
      },
    };

    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/bookcoupongroups-templates/findByFilter`;
    return this.http.post<QcResponse>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }

  changeGroupTemplateStatus(selectedRow: any): Observable<QcResponse> {
    const body = {
      bookCouponGroupPrefix: selectedRow.bookCouponGroupPrefix,
      bookCouponGroupTemplateId: selectedRow.bookCouponGroupTemplateId,
      bookCouponGroupTemplateLineList: selectedRow.bookCouponGroupTemplateLineList,
      bookCouponTypeId: selectedRow.bookCouponTypeId,
      code: selectedRow.code,
      deleteFlag: !selectedRow.deleteFlag,
      redeemPoints: selectedRow.redeemPoints,
      remarks: selectedRow.remarks,
    };

    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/bookcoupongroups-templates/update`;

    return this.http.put<QcResponse>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_ACTION, true),
    });
  }
}
